import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { SOCIAL_LINKS } from "../../constant/site";

import { useSelector } from "react-redux";
const Footer = () => {
  const { token } = useSelector((state) => state.auth);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const socialIconMap = {
    X: FaXTwitter,
    Facebook: FaFacebookF,
    Instagram: FaInstagram,
    YouTube: FaYoutube,
  };

  const socialLinks = SOCIAL_LINKS.map((link) => ({
    ...link,
    Icon: socialIconMap[link.label],
  })).filter((link) => link.href && link.Icon);

  const [stats, setStats] = useState({
    totalUsers: 0,
    totalVisits: 0,
    totalNews: 0,
    totalCategories: 0,
    totalSubCategories: 0,
  });
  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/dashboard`);
        setStats(response.data);
      } catch (error) {
        console.error("Failed to fetch dashboard statistics", error);
      }
    };

    fetchStats();
  }, [BASE_URL]);
  return (
    <footer className="bg-[#730101]  border-t-2 border-red-600">
      <div className="container mx-auto py-2">
        <div className="flex justify-center flex-wrap text-sm space-x-4 text-white">
          <Link to="/" className="hover:underline">
            देश
          </Link>
          <span>|</span>
          <Link to="/" className="hover:underline">
            विदेश
          </Link>
          <span>|</span>
          <Link to="/" className="hover:underline">
            राजनीति
          </Link>
          <span>|</span>
          <Link to="/" className="hover:underline">
            मध्य प्रदेश
          </Link>
          <span>|</span>
          <Link to="/" className="hover:underline">
            छत्तीसगढ़
          </Link>
          <span>|</span>
          <Link to="/" className="hover:underline">
            खेल
          </Link>
          <span>|</span>
          <Link to="/" className="hover:underline">
            व्यापार
          </Link>
          <span>|</span>
          <Link to="/" className="hover:underline">
            मनोरंजन
          </Link>
          <span>|</span>
          <Link to="/" className="hover:underline">
            धर्म एवं ज्योतिष
          </Link>
          <span>|</span>
          <Link to="/" className="hover:underline">
            लाइफ स्टाइल
          </Link>
          <span>|</span>
          <Link to="/" className="hover:underline">
            दिल्ली/NCR
          </Link>
        </div>
        {socialLinks.length > 0 && (
          <div className="flex justify-center items-center gap-3 py-3 text-white text-lg">
            {socialLinks.map(({ href, label, Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="me noopener noreferrer"
                aria-label={label}
                className="bg-green-900 p-2 rounded-full hover:bg-green-800"
              >
                <Icon />
              </a>
            ))}
          </div>
        )}
        <div className="flex justify-center items-center py-4 border-t mt-4">
          <div className="flex space-x-4 text-white text-sm">
            <Link to="/about" className="hover:underline">
              हमारे बारे में
            </Link>
            <span>|</span>
            <Link to="/contact" className="hover:underline">
              Contact Us
            </Link>
            <span>|</span>
            <Link to="/archive" className="hover:underline">
              Archive
            </Link>
            <span>|</span>

            {token ? (
              <Link to="/admin/dashboard" className="hover:underline">
                Admin Login
              </Link>
            ) : (
              <Link to="/login" className="hover:underline">
                Admin Login
              </Link>
            )}
          </div>
        </div>
      </div>
      <div className="bg-[#730101] text-white text-center py-2">
        All Rights Reserved. <br />
        <p> Visits :- {stats.totalVisits}</p>
      </div>
    </footer>
  );
};

export default Footer;
